module.exports = __webpack_public_path__ + "static/media/Do Your Thing - Instrumental Version.894d88ec.jpg";